import React from "react"

import { EmailVerificationPage } from "./EmailVerificationPage"
import { useEmailVerificationPageModel } from "./hooks/useEmailVerificationPageModel"

export const EmailVerificationPageConnector = React.memo(() => {
  return <EmailVerificationPage {...useEmailVerificationPageModel()} />
})
